import {
  IDeclaracaoTitularArrendatarioNaoIniciada,
  IDeclaracaoTitularOuArrendatario,
  IDeclaracaoTitularOuArrendatarioEditar,
  IDeclaracaoTitularOuArrendatarioExistente,
} from '../../../interfaces/IDeclaracoes';
import {
  IFilialEnvio,
  IFilialLista,
  IIdentificacaoBasica,
  IProcessoJuridico,
} from '../../../interfaces/IIdentificacaoBasica';
import { IMunicipio, IProcessoMinerario, IProcessosADeclararListaSuspensa } from '../../../interfaces/IProcessos';
import { useApiClient } from '../../../hooks/useApiClient';
import { ICodigoNcm } from '../../../interfaces/ICodigoNcm';
import {
  IDadosOutrosRegimes,
  IDadosOutrosRegimesEnviar,
  IListaBaseCalculo,
  IRetornoListagemBaseCalculo,
} from '../../../interfaces/IDadosOutrosRegimes';
import {
  IBalneario,
  IBalnearioComBanhoSalvar,
  IBalnearioInformacoesComBanhoEnviar,
  IBalnearioInformacoesComBanhoReceber,
  IBalnearioInformacoesSemBanhoEnviar,
  IBalnearioInformacoesSemBanhoReceber,
  IBalnearioSemBanhoSalvar,
} from '../../../interfaces/IBalneario';
import { IOperacao, IOperacaoListagem, IPLGResumo } from '../../../interfaces/IOperacaoPLG';
import {
  IRepasseParceiro,
  IVendaDireta,
  ICodigoNcm as ICodigoNcmBaseCalculo,
} from '../../../interfaces/IBaseDeCalculo';
import {
  IConfiguracaoOutrosRegimes,
  IRequisicaoSalvarConfiguracao,
  IRetornoListagemOutrosRegimes,
  IRetornoOutrosRegimesResumo,
} from '../../../interfaces/IOperacoes';
import { ITributos } from '../../../interfaces/ITributos';
import {
  IReceitaBrutaNCMEnviar,
  IReceitaBrutaNCMReceber,
  IReceitaBruta,
  IInformacaoReceitaBruta,
  IInformacaoReceitaBrutaEnviar,
} from '../../../interfaces/IReceitaBruta';
import {
  IInformacaoReceitaBrutaCalculada,
  INCMReceitaBrutaCalculada,
  INCMReceitaBrutaCalculadaPrecoCorrente,
  INCMReceitaBrutaCalculadaValorReferencia,
  IReceitaBrutaCalculadaNCMReceber,
  IRequisicaoReceitaBrutaCalculadaPrecoCorrente,
  IRequisicaoReceitaBrutaCalculadaValorReferencia,
} from '../../../interfaces/IReceitaBrutaCalculada';
import {
  IDadosPessoaRelacionadaEnviar,
  IInformacaoVendaNacional,
  IInformacaoVendaNacionalEnviar,
  IVendaNacional,
  IVendaNacionalNCMEnviar,
  IVendaNacionalNCMReceber,
} from '../../../interfaces/IVendaNacional';
import {
  IFatoresAjuste,
  IReceitaExportacoes,
  IReceitaExportacoesNCM,
  IReceitaExportacoesNCMAtualizarInformacoes,
  IReceitaExportacoesNCMEnviar,
  IReceitaExportacoesNCMVinculadaAtualizarInformacoes,
  IReceitaExportacoesVinculadaNCM,
  IReceitaExportacoesVinculadaNCMEnviar,
} from '../../../interfaces/IReceitaExportacoes';
import { IRegimeTributacao } from 'interfaces/IRegimeTributacao';

export const useBackEndRequests = () => {
  const httpCall = useApiClient();

  const getDeclaracoes = async (cnpj: string, ano: string, tipo: number) => {
    const resposta = await httpCall.get<IDeclaracaoTitularOuArrendatarioExistente[]>(
      `/dief-cfem/api/declaracao/titular-arrendatario/listar/${cnpj}/ano/${ano}`
    );

    return resposta.data;
  };

  const getIdentificacaoBasica = async (cnpj: string) => {
    const resposta = await httpCall.get<IIdentificacaoBasica>(`/dief-cfem/api/declarante/${cnpj}`);

    return resposta.data;
  };

  const getListaProcessosPLG = async (cnpj: string, mesExercicio: string, anoExercicio: string) => {
    const resposta = await httpCall.get<string[]>(
      `/dief-cfem/api/processo-minerario/titular-arrendatario/plg/${cnpj}/mes-exercicio/${mesExercicio}/ano-exercicio/${anoExercicio}`
    );

    return resposta.data;
  };

  const getListaOutrosProcessos = async (id: string, page: number, size: number) => {
    const resposta = await httpCall.get<IRetornoListagemOutrosRegimes>(
      `dief-cfem/api/processo-minerario/titular-arrendatario/outros-regimes/processos/${id}?page=${page}&size=${size}`
    );

    return resposta.data;
  };

  const getConfiguracaoOperacional = async (id: string) => {
    const resposta = await httpCall.get<IConfiguracaoOutrosRegimes>(
      `dief-cfem/api/processo-minerario/titular-arrendatario/outros-regimes/processos-resumo/${id}`
    );

    return resposta.data;
  };

  const postSalvarConfiguracao = async (configuracao: IRequisicaoSalvarConfiguracao) => {
    const resposta = await httpCall.post<any>(
      `dief-cfem/api/declaracao-processo-configuracao/outros-regimes/salvar-configuracao`,
      configuracao
    );

    return resposta.data;
  };

  const getProcessoPLG = async (numeroProcesso: string) => {
    const resposta = await httpCall.get<IProcessoMinerario>(
      `/dief-cfem/api/processo-minerario/lavra-garimpeira/${numeroProcesso}`
    );

    return resposta.data;
  };

  const postCadastrarDeclaracaoInicial = async (declaracao: IDeclaracaoTitularOuArrendatario) => {
    await httpCall
      .post<IDeclaracaoTitularOuArrendatario>(`/dief-cfem/api/declaracao/titular-arrendatario/`, declaracao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const putCadastrarDeclaracaoInicial = async (declaracao: IDeclaracaoTitularOuArrendatarioEditar) => {
    await httpCall
      .put<IDeclaracaoTitularOuArrendatario>(`/dief-cfem/api/declaracao/titular-arrendatario/`, declaracao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const postEnviarDeclaracao = async (declaracaoID: string) => {
    await httpCall
      .post<IDeclaracaoTitularOuArrendatario>(`/dief-cfem/api/declaracao/titular-arrendatario/enviar/${declaracaoID}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getMunicipioByCodigoIBGE = async (codigoIBGE: string) => {
    const resposta = await httpCall.get<IMunicipio>(`/dief-cfem/api/localidade/municipio/${codigoIBGE}`);
    return resposta.data;
  };

  const getDeclaracaoById = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoTitularOuArrendatario>(`/dief-cfem/api/declaracao/${declaracaoID}`);
    return resposta.data;
  };

  const getCodigosNCM = async () => {
    const resposta = await httpCall.get<ICodigoNcm[]>(`/dief-cfem/api/ncm`);

    return resposta.data;
  };

  const getDeclaracoesNaoIniciadas = async (cnpj: string, ano: string, tipo: number) => {
    const resposta = await httpCall.get<IDeclaracaoTitularArrendatarioNaoIniciada[]>(
      `/dief-cfem/api/declaracao/titular-arrendatario/nao-iniciadas/${cnpj}/ano/${ano}`
    );

    return resposta.data;
  };

  const getDeclaracaoTitularArrendatarioPLGById = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoTitularOuArrendatario>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/${declaracaoID}`
    );
    return resposta.data;
  };

  const getDeclaracaoResumoPLGById = async (declaracaoId: string) => {
    const resposta = await httpCall.get<IPLGResumo>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/visualizar-resumo/${declaracaoId}`
    );

    return resposta.data;
  };

  const postCadastrarOperacaoPLGItem = async (operacao: IOperacao) => {
    const resposta = await httpCall
      .post<IOperacao>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/declaracao-item`, operacao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const postCadastrarVendaDireta = async (operacao: IVendaDireta) => {
    const resposta = await httpCall
      .post<IVendaDireta>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/venda-direta/`, operacao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    return resposta.data;
  };

  const postCadastrarVendaDiretaItem = async (ncmItem: ICodigoNcmBaseCalculo) => {
    const resposta = await httpCall
      .post<ICodigoNcmBaseCalculo>(
        `/dief-cfem/api/declaracao/titular-arrendatario/plg/venda-direta/item-operacao`,
        ncmItem
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const postCadastrarRepasseParceiro = async (operacao: IRepasseParceiro) => {
    const resposta = await httpCall
      .post<IRepasseParceiro>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/repasse/`, operacao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    return resposta.data;
  };

  const postCadastrarRepasseParceiroItem = async (ncmItem: ICodigoNcmBaseCalculo) => {
    const resposta = await httpCall
      .post<ICodigoNcmBaseCalculo>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/repasse/item-operacao`, ncmItem)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const getOperacoesByDeclaracaoId = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IOperacaoListagem>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/visualizar/${declaracaoID}`
    );
    return resposta.data;
  };

  const deleteOperacaoPLG = async (idDeclaracaoItem: number) => {
    const resposta = await httpCall.delete<string>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/declaracao-item/${idDeclaracaoItem}`
    );
    return resposta.data;
  };

  const getVendaDiretaById = async (idVendaDireta: number) => {
    const resposta = await httpCall.get<IVendaDireta>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/venda-direta/${idVendaDireta}`
    );
    return resposta.data;
  };

  const getRepasseParceiroById = async (idRepasseParceiro: number) => {
    const resposta = await httpCall.get<IRepasseParceiro>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/repasse/${idRepasseParceiro}`
    );
    return resposta.data;
  };

  const getOperacaoPLGById = async (idOperacao: number) => {
    const resposta = await httpCall.get<IOperacao>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/${idOperacao}`);
    return resposta.data;
  };

  const deleteVendaDiretaItemPLG = async (idVendaDiretaItem: number) => {
    const resposta = await httpCall.delete<string>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/venda-direta/item-operacao/${idVendaDiretaItem}`
    );
    return resposta.data;
  };

  const deleteRepasseParceiroItemPLG = async (idRepasseParceiroItem: number) => {
    const resposta = await httpCall.delete<string>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/repasse/item-operacao/${idRepasseParceiroItem}`
    );
    return resposta.data;
  };

  const deleteRepasseParceiroPLG = async (idRepasseParceiro: number) => {
    const resposta = await httpCall.delete<string>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/repasse/${idRepasseParceiro}`
    );
    return resposta.data;
  };

  const deleteVendaDiretaPLG = async (idVendaDireta: number) => {
    const resposta = await httpCall.delete<string>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/venda-direta/${idVendaDireta}`
    );
    return resposta.data;
  };

  const putEditarVendaDiretaItem = async (ncmItem: ICodigoNcmBaseCalculo) => {
    const resposta = await httpCall
      .put<ICodigoNcmBaseCalculo>(
        `/dief-cfem/api/declaracao/titular-arrendatario/plg/venda-direta/item-operacao`,
        ncmItem
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putEditarRepasseParceiroItem = async (ncmItem: ICodigoNcmBaseCalculo) => {
    const resposta = await httpCall
      .put<ICodigoNcmBaseCalculo>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/repasse/item-operacao`, ncmItem)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putEditarRepasseParceiro = async (repasse: IRepasseParceiro) => {
    const resposta = await httpCall
      .put<IRepasseParceiro>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/repasse/`, repasse)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putEditarVendaDireta = async (vendaDireta: IVendaDireta) => {
    const resposta = await httpCall
      .put<IVendaDireta>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/venda-direta/`, vendaDireta)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putEditarOperacaoPLGItem = async (operacao: IOperacao) => {
    const resposta = await httpCall
      .put<IOperacao>(`/dief-cfem/api/declaracao/titular-arrendatario/plg/declaracao-item`, operacao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const getDadosOperacaoOutrosRegimesById = async (operacaoId: string) => {
    const resposta = await httpCall.get<IDadosOutrosRegimes>(
      `/dief-cfem/api/declaracao/outros-regimes/operacao/${operacaoId}`
    );
    return resposta.data;
  };

  const putSalvarDadosOutrosRegimes = async (dados: IDadosOutrosRegimesEnviar) => {
    await httpCall
      .put<IDadosOutrosRegimesEnviar>(`/dief-cfem/api/declaracao/outros-regimes`, dados)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getMunicipioPorUf = async (uf: string) => {
    const resposta = await httpCall.get<IMunicipio[]>(`/dief-cfem/api/localidade/uf/${uf}`);

    return resposta.data;
  };

  const getListaBaseCalculoOutrosRegimes = async (operacaoId: string) => {
    const resposta = await httpCall.get<IListaBaseCalculo>(
      `/dief-cfem/api/declaracao/outros-regimes/operacao/base-calculo/visualizar/${operacaoId}`
    );
    return resposta.data;
  };

  const postSalvarBalnearioComBanho = async (dados: IBalnearioComBanhoSalvar) => {
    await httpCall
      .post<IBalnearioComBanhoSalvar>(
        `/dief-cfem/api/declaracao/outros-regimes/balneario/base-calculo/valor-banho`,
        dados
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const postSalvarBalnearioSemBanho = async (dados: IBalnearioSemBanhoSalvar) => {
    await httpCall
      .post<IBalnearioSemBanhoSalvar>(
        `/dief-cfem/api/declaracao/outros-regimes/balneario/base-calculo/outros-valores`,
        dados
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const putAtualizarBalnearioComBanho = async (dados: IBalnearioComBanhoSalvar) => {
    await httpCall
      .put<IBalnearioComBanhoSalvar>(
        `/dief-cfem/api/declaracao/outros-regimes/balneario/base-calculo/valor-banho`,
        dados
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const putAtualizarBalnearioSemBanho = async (dados: IBalnearioSemBanhoSalvar) => {
    await httpCall
      .put<IBalnearioSemBanhoSalvar>(
        `/dief-cfem/api/declaracao/outros-regimes/balneario/base-calculo/outros-valores`,
        dados
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getBalneario = async (houveBanho: boolean, id: number) => {
    const resposta = await httpCall.get<IBalneario>(
      `/dief-cfem/api/declaracao/outros-regimes/balneario/base-calculo/${houveBanho}/${id}`
    );
    return resposta.data;
  };

  const deleteBalneario = async (houveBanho: boolean, id: number) => {
    await httpCall
      .delete<IBalnearioSemBanhoSalvar>(
        `/dief-cfem/api/declaracao/outros-regimes/balneario/base-calculo/${houveBanho}/${id}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getBalnearioNCMs = async () => {
    const resposta = await httpCall.get<ICodigoNcm[]>(
      `/dief-cfem/api/declaracao/outros-regimes/balneario/ncm/visualizar`
    );
    return resposta.data;
  };

  const postFilial = async (filial: IFilialEnvio) => {
    await httpCall
      .post<IFilialEnvio>(`/dief-cfem/api/filial`, filial)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const deleteFilial = async (filialId: string) => {
    await httpCall
      .delete(`/dief-cfem/api/filial/${filialId}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getListaFiliais = async (declaracaoId: string) => {
    const resposta = await httpCall.get<IFilialLista[]>(`/dief-cfem/api/filial/declaracao/${declaracaoId}`);

    return resposta.data;
  };

  const getListaProcessoJuridico = async (declaracaoId: string) => {
    const resposta = await httpCall.get<IProcessoJuridico[]>(
      `/dief-cfem/api/processo-judicial/declaracao/${declaracaoId}`
    );

    return resposta.data;
  };

  const postProcessoJuridicio = async (processoJuridico: IProcessoJuridico) => {
    await httpCall
      .post<IFilialEnvio>(`/dief-cfem/api/processo-judicial`, processoJuridico)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const deleteProcessoJuridicoById = async (processoJudicialId: number) => {
    await httpCall
      .delete<any>(`/dief-cfem/api/processo-judicial/${processoJudicialId}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const deleteAllProcessosJuridicos = async (declaracaoId: string) => {
    await httpCall
      .delete<any>(`/dief-cfem/api/processo-judicial/declaracao/${declaracaoId}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const putDeclaraDemaisProcessosSemOperacoes = async (declaracaoId: string) => {
    const resposta = await httpCall
      .put<boolean>(
        `/dief-cfem/api/declaracao/titular-arrendatario/plg/declarar-demais-processos-sem-operacoes/${declaracaoId}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putDeclaraProcessosOutrosRegimesSemOperacoes = async (declaracaoId: string) => {
    const resposta = await httpCall
      .put<boolean>(`/dief-cfem/api/declaracao/outros-regimes/declarar-demais-processos-sem-operacoes/${declaracaoId}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const getResumoOutrosRegimesByDeclaracaoId = async (
    declaracaoId: string,
    page: number,
    size: number,
    isExibirProcessoSemPreenchimento: boolean
  ) => {
    const resposta = await httpCall.get<IRetornoOutrosRegimesResumo>(
      `/dief-cfem/api/declaracao/outros-regimes/visualizar-resumo/${declaracaoId}?page=${page}&size=${size}&isExibirProcessoSemPreenchimento=${isExibirProcessoSemPreenchimento}`
    );

    return resposta.data;
  };

  const getEstabelecimentosMineradores = async (declaracaoId: string) => {
    const resposta = await httpCall.get<string[]>(
      `/dief-cfem/api/declaracao/outros-regimes/estabelecimento-minerador/${declaracaoId}`
    );

    return resposta.data;
  };

  const getTributosPossiveis = async (declaracaoItemId: string) => {
    const resposta = await httpCall.get<ITributos>(
      `/dief-cfem/api/declaracao/outros-regimes/balneario/tributo?declaracaoItemId=${declaracaoItemId}`
    );

    return resposta.data;
  };

  const postReceberInformacaoBalnearioSemBanho = async (body: IBalnearioInformacoesSemBanhoEnviar) => {
    const resposta = await httpCall
      .post<IBalnearioInformacoesSemBanhoReceber>(
        `/dief-cfem/api/declaracao/outros-regimes/balneario/tributos/outros-valores/visualizar`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const postReceberInformacaoBalnearioComBanho = async (body: IBalnearioInformacoesComBanhoEnviar) => {
    const resposta = await httpCall
      .post<IBalnearioInformacoesComBanhoReceber>(
        `/dief-cfem/api/declaracao/outros-regimes/balneario/tributos/valor-banho/visualizar`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const getProcessosData = async (numeroProcesso: string) => {
    const resposta = await httpCall.get<IProcessoMinerario>(
      `/dief-cfem/api/processo-minerario/hasta-publica/${numeroProcesso}`
    );

    return resposta.data;
  };

  const getReportRecibo = async (declaracaoID: string) => {
    const resposta = await httpCall.get<Blob>(`/dief-cfem/api/report/titular-arrendatario/recibo/${declaracaoID}`, {
      responseType: 'blob',
    });

    return resposta.data;
  };

  const getReportDeclaracaoResumida = async (declaracaoID: string) => {
    const resposta = await httpCall.get<Blob>(
      `/dief-cfem/api/report/titular-arrendatario/declaracao-resumida/${declaracaoID}`,
      {
        responseType: 'blob',
      }
    );

    return resposta.data;
  };

  const getReportDeclaracaoCompleta = async (declaracaoID: string) => {
    const resposta = await httpCall.get<Blob>(`/dief-cfem/api/report/titular-arrendatario/declaracao/${declaracaoID}`, {
      responseType: 'blob',
    });

    return resposta.data;
  };

  const getNCMReceitaBruta = async () => {
    const resposta = await httpCall.get<ICodigoNcm[]>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm/codigo-ncm-bem-mineral`
    );
    return resposta.data;
  };

  const getTributosReceitaBruta = async (declaracaoItemId: string) => {
    const resposta = await httpCall.get<ITributos>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/tributo?declaracaoItemId=${declaracaoItemId}`
    );
    return resposta.data;
  };

  const getUnidadesMedidaReceitaBruta = async () => {
    const resposta = await httpCall.get<string[]>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm/unidade-medida`
    );
    return resposta.data;
  };

  const postReceitaBruta = async (declaracaoItemId: string) => {
    const resposta = await httpCall
      .post<IReceitaBruta>(`/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas`, {
        declaracaoItemId: declaracaoItemId,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteReceitaBruta = async (id: number) => {
    await httpCall
      .delete(`/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/${id}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const postNCMReceitaBruta = async (body: IReceitaBrutaNCMEnviar) => {
    const resposta = await httpCall
      .post<IReceitaBrutaNCMReceber>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putNCMReceitaBruta = async (body: IReceitaBrutaNCMEnviar) => {
    const resposta = await httpCall
      .put<IReceitaBrutaNCMReceber>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteNCMReceitaBruta = async (id: number) => {
    await httpCall
      .delete(`/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm/${id}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getListaNCMsAdicionadosReceitaBruta = async (id: number) => {
    const resposta = await httpCall.get<IReceitaBrutaNCMReceber[]>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm/visualizar/${id}`
    );
    return resposta.data;
  };

  const getNCMAdicionadoReceitaBruta = async (id: number) => {
    const resposta = await httpCall.get<IReceitaBrutaNCMReceber>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm/${id}`
    );
    return resposta.data;
  };

  const postReceberInformacoesReceitaBruta = async (body: IInformacaoReceitaBrutaEnviar) => {
    const resposta = await httpCall
      .post<IInformacaoReceitaBruta>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-vendas/ncm/visualizar-informacoes-tributos-incidentes`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const postDadosPessoaRelacionada = async (body: IDadosPessoaRelacionadaEnviar) => {
    const resposta = await httpCall
      .post<IVendaNacional>(`/dief-cfem/api/declaracao/outros-regimes/venda-nacional`, body)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    return resposta.data;
  };

  const deleteReceitaBrutaCalculada = async (id: number) => {
    await httpCall
      .delete(`/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/${id}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const putDadosPessoaRelacionada = async (body: IDadosPessoaRelacionadaEnviar) => {
    const resposta = await httpCall
      .put<IVendaNacional>(`/dief-cfem/api/declaracao/outros-regimes/venda-nacional`, body)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const getVendaNacional = async (id: number) => {
    const resposta = await httpCall.get<IVendaNacional>(
      `/dief-cfem/api/declaracao/outros-regimes/venda-nacional/${id}`
    );
    return resposta.data;
  };

  const getNCMVendaNacional = async () => {
    const resposta = await httpCall.get<ICodigoNcm[]>(
      `/dief-cfem/api/declaracao/outros-regimes/venda-nacional/codigo-ncm`
    );
    return resposta.data;
  };

  const getTributosVendaNacional = async (declaracaoItemId: string) => {
    const resposta = await httpCall.get<ITributos>(
      `/dief-cfem/api/declaracao/outros-regimes/venda-nacional/tributo?declaracaoItemId=${declaracaoItemId}`
    );
    return resposta.data;
  };

  const getUnidadesMedidaVendaNacional = async () => {
    const resposta = await httpCall.get<string[]>(
      `/dief-cfem/api/declaracao/outros-regimes/venda-nacional/unidade-medida`
    );
    return resposta.data;
  };

  const postNCMVendaNacional = async (body: IVendaNacionalNCMEnviar) => {
    const resposta = await httpCall
      .post<IVendaNacionalNCMReceber>(`/dief-cfem/api/declaracao/outros-regimes/venda-nacional/ncm`, body)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putNCMVendaNacional = async (body: IVendaNacionalNCMEnviar, id: number) => {
    const resposta = await httpCall
      .put<IVendaNacionalNCMReceber>(`/dief-cfem/api/declaracao/outros-regimes/venda-nacional/ncm`, body)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteNCMVendaNacional = async (id: number) => {
    const resposta = await httpCall
      .delete(`/dief-cfem/api/declaracao/outros-regimes/venda-nacional/ncm/${id}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    return resposta.data;
  };

  const getNCMAdicionadoVendaNacional = async (id: number) => {
    const resposta = await httpCall.get<IVendaNacionalNCMReceber>(
      `/dief-cfem/api/declaracao/outros-regimes/venda-nacional/ncm/${id}`
    );
    return resposta.data;
  };

  const postReceberInformacoesVendaNacional = async (body: IInformacaoVendaNacionalEnviar) => {
    const resposta = await httpCall
      .post<IInformacaoVendaNacional>(
        `/dief-cfem/api/declaracao/outros-regimes/venda-nacional/ncm/visualizar-informacoes-tributos-incidentes`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const postVendaNacional = async (declaracaoItemId: string) => {
    const resposta = await httpCall
      .post<IReceitaBruta>(`/dief-cfem/api/declaracao/outros-regimes/venda-nacional`, {
        declaracaoItemId: declaracaoItemId,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteVendaNacional = async (id: number) => {
    await httpCall
      .delete(`/dief-cfem/api/declaracao/outros-regimes/venda-nacional/${id}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getListaNCMsAdicionadosVendaNacional = async (id: number) => {
    const resposta = await httpCall.get<IVendaNacionalNCMReceber[]>(
      `/dief-cfem/api/declaracao/outros-regimes/venda-nacional/visualizar/${id}`
    );
    return resposta.data;
  };

  const getListaNCMsAdicionadosReceitaBrutaCalculada = async (id: number) => {
    const resposta = await httpCall.get<IReceitaBrutaCalculadaNCMReceber>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/${id}`
    );
    return resposta.data;
  };

  const getTributosReceitaBrutaCalculada = async (declaracaoItemId: string) => {
    const resposta = await httpCall.get<ITributos>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/tributo?declaracaoItemId=${declaracaoItemId}`
    );
    return resposta.data;
  };

  const postReceitaBrutaCalculada = async (declaracaoItemId: string) => {
    const resposta = await httpCall
      .post<IReceitaBruta>(`/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada`, {
        idDeclaracaoItem: declaracaoItemId,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    return resposta.data;
  };

  const getNCMAdicionadoReceitaBrutaCalculadaPrecoCorrente = async (id: number) => {
    const resposta = await httpCall.get<INCMReceitaBrutaCalculadaPrecoCorrente>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/preco-corrente/${id}`
    );
    return resposta.data;
  };

  const postSalvarNCMReceitaBrutaCalculadaPrecoCorrente = async (
    body: IRequisicaoReceitaBrutaCalculadaPrecoCorrente
  ) => {
    const resposta = await httpCall
      .post<INCMReceitaBrutaCalculada>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/preco-corrente`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const getFatoresAjusteReceitaBrutaCalculada = async (idDeclaracao: number) => {
    const resposta = await httpCall.get<any>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/valor-referencia/fatores-ajuste/${idDeclaracao}`
    );
    return resposta.data;
  };

  const postReceberInformacoesReceitaBrutaCalculadaPrecoCorrente = async (
    body: IRequisicaoReceitaBrutaCalculadaPrecoCorrente
  ) => {
    const resposta = await httpCall
      .post<IInformacaoReceitaBrutaCalculada>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/preco-corrente/atualizar-informacoes`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    return resposta.data;
  };

  const postReceberInformacoesReceitaBrutaCalculadaValorReferencia = async (
    body: IRequisicaoReceitaBrutaCalculadaValorReferencia
  ) => {
    const resposta = await httpCall
      .post<IInformacaoReceitaBrutaCalculada>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/valor-referencia/atualizar-informacoes`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    return resposta.data;
  };

  const putSalvarNCMReceitaBrutaCalculadaPrecoCorrente = async (
    body: IRequisicaoReceitaBrutaCalculadaPrecoCorrente
  ) => {
    const resposta = await httpCall
      .put<INCMReceitaBrutaCalculada>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/preco-corrente`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteNCMReceitaBrutaCalculadaPrecoCorrente = async (id: number) => {
    await httpCall
      .delete(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/preco-corrente/${id}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getNCMAdicionadoReceitaBrutaCalculadaValorReferencia = async (id: number) => {
    const resposta = await httpCall.get<INCMReceitaBrutaCalculadaValorReferencia>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/valor-referencia/${id}`
    );
    return resposta.data;
  };

  const postSalvarNCMReceitaBrutaCalculadaValorReferencia = async (
    body: IRequisicaoReceitaBrutaCalculadaValorReferencia
  ) => {
    const resposta = await httpCall
      .post<INCMReceitaBrutaCalculadaValorReferencia>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/valor-referencia`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putSalvarNCMReceitaBrutaCalculadaValorReferencia = async (
    body: IRequisicaoReceitaBrutaCalculadaValorReferencia
  ) => {
    const resposta = await httpCall
      .put<INCMReceitaBrutaCalculada>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/valor-referencia`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteNCMReceitaBrutaCalculadaValorReferencia = async (id: number) => {
    await httpCall
      .delete(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-bruta-calculada/item/valor-referencia/${id}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getUnidadeMedidaReceitaExportacoes = async () => {
    const resposta = await httpCall.get<string[]>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item/unidade-medida`
    );
    return resposta.data;
  };

  const getNCMReceitaExportacoes = async () => {
    const resposta = await httpCall.get<ICodigoNcm[]>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item/codigo-ncm-bem-mineral`
    );
    return resposta.data;
  };

  const getTributosReceitaExportacoes = async (declaracaoItemId: string) => {
    const resposta = await httpCall.get<ITributos>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/tributo?declaracaoItemId=${declaracaoItemId}`
    );
    return resposta.data;
  };

  const getFatoresAjusteReceitaExportacoes = async (idDeclaracaoItem: string) => {
    const resposta = await httpCall.get<IFatoresAjuste>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item/fatores-ajuste/${idDeclaracaoItem}`
    );
    return resposta.data;
  };

  const postReceitaExportacoes = async (idOperacao: string) => {
    const resposta = await httpCall
      .post<IReceitaExportacoes>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes`,
        {
          idDeclaracaoItem: idOperacao,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteReceitaExportacoes = async (id: number) => {
    await httpCall
      .delete(`/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/${id}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getMetodoApuracaoPrecos = async () => {
    const resposta = await httpCall.get<string[]>('/dief-cfem/api/metodo-apuracao-preco/nomes');
    return resposta.data;
  };

  const postNCMReceitaExportacoes = async (body: IReceitaExportacoesNCMEnviar) => {
    const resposta = await httpCall
      .post<IReceitaExportacoesNCM>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putNCMReceitaExportacoes = async (body: IReceitaExportacoesNCMEnviar) => {
    const resposta = await httpCall
      .put<IReceitaExportacoesNCM>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteNCMReceitaExportacoes = async (id: number) => {
    await httpCall
      .delete(`/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item/${id}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const postNCMVinculadaReceitaExportacoes = async (body: IReceitaExportacoesVinculadaNCMEnviar) => {
    const resposta = await httpCall
      .post<IReceitaExportacoesVinculadaNCM>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes-vinculada/item`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const putNCMVinculadaReceitaExportacoes = async (body: IReceitaExportacoesVinculadaNCMEnviar) => {
    const resposta = await httpCall
      .put<IReceitaExportacoesVinculadaNCM>(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes-vinculada/item`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
    return resposta.data;
  };

  const deleteNCMVinculadaReceitaExportacoes = async (id: number) => {
    await httpCall
      .delete(
        `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes-vinculada/item/${id}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getNCMAdicionadoReceitaExportacoes = async (id: number) => {
    const resposta = await httpCall.get<IReceitaExportacoesNCM>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item/${id}`
    );
    return resposta.data;
  };

  const getNCMVinculadaAdicionadoReceitaExportacoes = async (id: number) => {
    const resposta = await httpCall.get<IReceitaExportacoesVinculadaNCM>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes-vinculada/item/${id}`
    );
    return resposta.data;
  };

  const getListaNCMsAdicionadoReceitaExportacoes = async (id: number) => {
    const resposta = await httpCall.get<IReceitaExportacoes>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/${id}`
    );
    return resposta.data;
  };

  const postReceberInformacoesNCMReceitaExportacoes = async (body: IReceitaExportacoesNCMEnviar) => {
    const resposta = await httpCall.post<IReceitaExportacoesNCMAtualizarInformacoes>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes/item/atualizar-informacoes`,
      body
    );
    return resposta.data;
  };

  const postReceberInformacoesNCMVinculadaReceitaExportacoes = async (body: IReceitaExportacoesVinculadaNCMEnviar) => {
    const resposta = await httpCall.post<IReceitaExportacoesNCMVinculadaAtualizarInformacoes>(
      `/dief-cfem/api/declaracao/titular-arrendatario/outros-regimes/receita-calculada-exportacoes-vinculada/item/atualizar-informacoes`,
      body
    );
    return resposta.data;
  };

  const getProcessosADeclarar = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IProcessosADeclararListaSuspensa[]>(
      `/dief-cfem/api/processo-minerario/titular-arrendatario/outros-regimes/processos-a-declarar/${declaracaoID}`
    );
    return resposta.data;
  };

  const postListaIdProcessosADeclarar = async (declaracaoId: string, processosIds: string[]) => {
    const resposta = await httpCall.post<any>(
      `/dief-cfem/api/processo-minerario/titular-arrendatario/outros-regimes/processos-resumo`,

      {
        declaracaoId,
        processosIds,
      }
    );
    return resposta.data;
  };

  const getListaFormacaoBaseCalculo = async (idDeclaracaoItem: string) => {
    const resposta = await httpCall.get<IRetornoListagemBaseCalculo[]>(
      `/dief-cfem/api/declaracao/outros-regimes/listar-formacao-base-calculo/${idDeclaracaoItem}`
    );
    return resposta.data;
  };

  const getCodigoNCMNovaEspecie = async (codigoNcm: string) => {
    const resposta = await httpCall.get<ICodigoNcm>(`/dief-cfem/api/ncm/codigo-ncm/${codigoNcm}`);
    return resposta.data;
  };

  const deleteDeclaracaoById = async (declaracaoID: string) => {
    const resposta = await httpCall.delete<IDeclaracaoTitularOuArrendatario>(
      `/dief-cfem/api/declaracao/retificacao/cancelar/${declaracaoID}`
    );
    return resposta.data;
  };

  const getRetificarDeclaracao = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoTitularOuArrendatario>(
      `/dief-cfem/api/declaracao/retificacao/retificar/${declaracaoID}`
    );
    return resposta.data;
  };

  const getRegimesTributacao = async (cpfCnpj: string) => {
    const resposta = await httpCall.get<IRegimeTributacao[]>(`/dief-cfem/api/regime-tributacao/${cpfCnpj}`);
    return resposta.data;
  };

  const checarCheckboxOutrosRegimes = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoTitularOuArrendatario>(
      `/dief-cfem/api/declaracao/outros-regimes/declarar-demais-processos-sem-operacoes/${declaracaoID}`
    );
    return resposta.data;
  };

  const checarCheckboxPLG = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoTitularOuArrendatario>(
      `/dief-cfem/api/declaracao/titular-arrendatario/plg/declarar-demais-processos-sem-operacoes/${declaracaoID}`
    );
    return resposta.data;
  };

  return {
    getDeclaracoes,
    getIdentificacaoBasica,
    getListaProcessosPLG,
    getConfiguracaoOperacional,
    postSalvarConfiguracao,
    getListaOutrosProcessos,
    getProcessoPLG,
    postCadastrarDeclaracaoInicial,
    putCadastrarDeclaracaoInicial,
    postEnviarDeclaracao,
    getMunicipioByCodigoIBGE,
    getDeclaracaoById,
    getCodigosNCM,
    getDeclaracoesNaoIniciadas,
    getDeclaracaoTitularArrendatarioPLGById,
    getDeclaracaoResumoPLGById,
    postCadastrarOperacaoPLGItem,
    postCadastrarVendaDireta,
    postCadastrarVendaDiretaItem,
    postCadastrarRepasseParceiro,
    postCadastrarRepasseParceiroItem,
    getOperacoesByDeclaracaoId,
    deleteOperacaoPLG,
    getBalnearioNCMs,
    getVendaDiretaById,
    getRepasseParceiroById,
    getOperacaoPLGById,
    deleteVendaDiretaItemPLG,
    deleteRepasseParceiroItemPLG,
    deleteRepasseParceiroPLG,
    deleteVendaDiretaPLG,
    putEditarVendaDiretaItem,
    putEditarRepasseParceiroItem,
    putEditarRepasseParceiro,
    putEditarVendaDireta,
    putEditarOperacaoPLGItem,
    putSalvarDadosOutrosRegimes,
    getListaBaseCalculoOutrosRegimes,
    postSalvarBalnearioComBanho,
    postSalvarBalnearioSemBanho,
    putAtualizarBalnearioComBanho,
    putAtualizarBalnearioSemBanho,
    getBalneario,
    deleteBalneario,
    getDadosOperacaoOutrosRegimesById,
    getMunicipioPorUf,
    postFilial,
    getListaFiliais,
    deleteFilial,
    getListaProcessoJuridico,
    postProcessoJuridicio,
    deleteProcessoJuridicoById,
    deleteAllProcessosJuridicos,
    putDeclaraDemaisProcessosSemOperacoes,
    putDeclaraProcessosOutrosRegimesSemOperacoes,
    checarCheckboxOutrosRegimes,
    checarCheckboxPLG,
    getResumoOutrosRegimesByDeclaracaoId,
    getEstabelecimentosMineradores,
    getTributosPossiveis,
    postReceberInformacaoBalnearioSemBanho,
    postReceberInformacaoBalnearioComBanho,
    getProcessosData,
    getReportRecibo,
    getReportDeclaracaoResumida,
    getReportDeclaracaoCompleta,
    getNCMReceitaBruta,
    getTributosReceitaBruta,
    getUnidadesMedidaReceitaBruta,
    postReceitaBruta,
    deleteReceitaBruta,
    postNCMReceitaBruta,
    putNCMReceitaBruta,
    deleteNCMReceitaBruta,
    getListaNCMsAdicionadosReceitaBruta,
    getNCMAdicionadoReceitaBruta,
    postReceberInformacoesReceitaBruta,
    postDadosPessoaRelacionada,
    putDadosPessoaRelacionada,
    getVendaNacional,
    getNCMVendaNacional,
    getTributosVendaNacional,
    getUnidadesMedidaVendaNacional,
    postNCMVendaNacional,
    putNCMVendaNacional,
    deleteNCMVendaNacional,
    getNCMAdicionadoVendaNacional,
    postReceberInformacoesVendaNacional,
    postVendaNacional,
    deleteVendaNacional,
    getListaNCMsAdicionadosVendaNacional,
    postReceitaBrutaCalculada,
    deleteReceitaBrutaCalculada,
    getListaNCMsAdicionadosReceitaBrutaCalculada,
    getFatoresAjusteReceitaBrutaCalculada,
    postReceberInformacoesReceitaBrutaCalculadaPrecoCorrente,
    postReceberInformacoesReceitaBrutaCalculadaValorReferencia,
    getNCMAdicionadoReceitaBrutaCalculadaPrecoCorrente,
    postSalvarNCMReceitaBrutaCalculadaPrecoCorrente,
    putSalvarNCMReceitaBrutaCalculadaPrecoCorrente,
    deleteNCMReceitaBrutaCalculadaPrecoCorrente,
    getNCMAdicionadoReceitaBrutaCalculadaValorReferencia,
    postSalvarNCMReceitaBrutaCalculadaValorReferencia,
    putSalvarNCMReceitaBrutaCalculadaValorReferencia,
    deleteNCMReceitaBrutaCalculadaValorReferencia,
    getUnidadeMedidaReceitaExportacoes,
    getNCMReceitaExportacoes,
    getFatoresAjusteReceitaExportacoes,
    postReceitaExportacoes,
    deleteReceitaExportacoes,
    getMetodoApuracaoPrecos,
    postNCMReceitaExportacoes,
    putNCMReceitaExportacoes,
    deleteNCMReceitaExportacoes,
    postNCMVinculadaReceitaExportacoes,
    putNCMVinculadaReceitaExportacoes,
    deleteNCMVinculadaReceitaExportacoes,
    getNCMAdicionadoReceitaExportacoes,
    getNCMVinculadaAdicionadoReceitaExportacoes,
    getListaNCMsAdicionadoReceitaExportacoes,
    postReceberInformacoesNCMReceitaExportacoes,
    postReceberInformacoesNCMVinculadaReceitaExportacoes,
    getProcessosADeclarar,
    postListaIdProcessosADeclarar,
    getListaFormacaoBaseCalculo,
    getCodigoNCMNovaEspecie,
    deleteDeclaracaoById,
    getRetificarDeclaracao,
    getRegimesTributacao,
    getTributosReceitaBrutaCalculada,
    getTributosReceitaExportacoes,
  };
};
